import { publicRoutes } from './public';
import { protectedRoutes } from './protected';
import Unauthorized from 'pages/unauthorized/unauthorized';

const routes = [
  ...publicRoutes,
  ...protectedRoutes,
  {
    layout: null,
    permission: [],
    name: 'Unauthorized',
    path: '/unauthorized',
    component: Unauthorized
  },
  {
    path: '*',
    layout: null,
    permission: [],
    name: 'Not Found',
    component: () => <h2>Page not found!</h2>
  }
];

export default routes;
